<template>

  <svg
    t="1640065869771"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4145"
    width="64"
    height="64"
  ><path d="M512 92a240 240 0 0 1 240 240v90h60a60 60 0 0 1 60 60v390a60 60 0 0 1-60 60H212a60 60 0 0 1-60-60V482a60 60 0 0 1 60-60h60v-90a240 240 0 0 1 240-240z m300 390H212v390h600V482z m-300 90a60 60 0 0 1 30.03 111.96L542 752a30 30 0 0 1-60 0v-68.04A60 60 0 0 1 512 572z m0-420a180 180 0 0 0-180 180v90h360v-90a180 180 0 0 0-180-180z" p-id="4146" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconLock',
} as DefineComponent
</script>